import * as Highcharts from 'highcharts';
import highchartsExporting from 'highcharts/modules/exporting';
import highchartsExportData from 'highcharts/modules/export-data';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import Chart from '../common/Chart';
import ChartProvider from '../../contexts/ChartContext';
dayjs.extend(dayOfYear);

highchartsExporting(Highcharts);
highchartsExportData(Highcharts);
noDataToDisplay(Highcharts);

type Props = {
  reference: any;
  solutions: any;
};

const ProductionChart = ({ reference, solutions }: Props) => {
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    if (solutions.length) {
      prepareData();
    }
    //}
  }, [reference, solutions]);

  const prepareData = () => {
    let dataObject: any = {
      times: [],
      values: {},
      units: {},
      title: 'Production',
      xTitle: 'Production (MWh/day)',
    };
    dataObject['times'] = reference?.times;
    dataObject['values'] = {
      production: reference?.values?.production,
      no_soiling_production: reference?.values?.no_soiling_production,
    };
    dataObject['units'] = reference?.units;
    solutions?.forEach((item: any) => {
      dataObject['values'][item.name + '_production'] = item?.data?.daily?.values?.production;
      dataObject['units'][item.name + '_production'] = item?.data?.daily?.units?.production;
    });
    setData(dataObject);
  };

  return (
    <>
      <Box sx={{ justifyContent: 'center', pl: 1, pr: 1 }}>
        {reference && (
          <>
            <ChartProvider>
              <Box>
                <Chart {...({ data } as any)} />
              </Box>
            </ChartProvider>
          </>
        )}
      </Box>
    </>
  );
};

export default ProductionChart;
